import { render } from "./Regulations.vue?vue&type=template&id=418c7bc7&scoped=true"
import script from "./Regulations.vue?vue&type=script&lang=js"
export * from "./Regulations.vue?vue&type=script&lang=js"

import "./Regulations.vue?vue&type=style&index=0&id=418c7bc7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-418c7bc7"]])

export default __exports__